/**
 * en-GB messages added by Phase 4 task S41 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s41EnGB = {
    'nav.billing': 'Billing',
    'nav.platform.billing': 'Billing',
    // Invoice email (fixed template billing.invoice_issued)
    'email.billing.invoice_issued.subject': '{tenant}: {document} {number}',
    'email.billing.invoice_issued.body': 'Your {document} {number} for {amount} is attached. You can also see it any time on the Billing page.',
    'email.billing.invoice_issued.button': 'Open billing',
    // Errors (messageKey of 409 answers)
    'billing.error.invoice_issued': 'An issued invoice cannot be changed. Issue a credit note instead.',
    'billing.error.invoice_empty': 'The invoice has no lines.',
    'billing.error.invoice_not_issued': 'Only an issued invoice can be credited.',
    'billing.error.not_an_invoice': 'Only an invoice can be credited or paid.',
    'billing.error.already_credited': 'This invoice has already been credited.',
    'billing.error.credit_lines_required': 'Choose the whole invoice or add at least one credit line.',
    'billing.error.credit_exceeds_invoice': 'The credit is more than the invoice still has left to credit.',
    'billing.error.payment_not_allowed': 'Payments can only be recorded against an issued invoice.',
    'billing.error.payment_exceeds_balance': 'The payment is more than the balance of the invoice.',
    'billing.error.plan_code_taken': 'That plan code is already used.',
    'billing.error.plan_inactive': 'That plan is no longer on offer.',
    'billing.error.subscription_exists': 'This organisation already has a subscription.',
    'billing.error.subscription_cancelled': 'This subscription is cancelled.',
    'billing.error.period_change_at_period_end': 'Changing between monthly and annual billing only takes effect at the end of the period.',
};
//# sourceMappingURL=s41.js.map